import React, { useState } from "react";
import _ from "lodash";
// reactstrap components
import {
    Media
} from "reactstrap";
// core components
import { withTranslation } from "react-i18next";
import { Upload } from "antd";
import "antd/dist/antd.css";
import MessageBox from "../../../../components/ui/MessageBox";
import * as Helper from "../../../../utils/Helper";
import * as UnitHelper from "../../../../utils/UnitHelper";
import WordEditService from "../../../../services/screens/admin/dictionary/word/EditService";
import UIDs from "../../../../UIDs";
import "../../../../assets/scss/screens/admin/unit/fields/types/uploadImage.scss";

const uid = UIDs.screens.admin.dictionary.word.imagefield;
const { Dragger } = Upload;

const ImageField = (props) => {

    ImageField.getPastePic = getPastePic
    // const { formMethods, values, resourceId } = props;
    const { formMethods, fields } = props;

    const { register, errors } = formMethods;

    let { choiceNum } = props;
    if (!choiceNum) {
        choiceNum = 6;
    }

    let choices = fields.choices.value;
    let choicesFieldName = UnitHelper.buildFieldName(fields.choices);
    let choicesFieldError = UnitHelper.findFieldError(errors, fields.choices);

    // store all uploaded image choices
    const [state_choices, setstate_choices] = useState(choices || []);

    // represent the image uploading button status
    const [state_choiceLoading, setstate_choiceLoading] = useState("");

    //粘贴图显示样式
    const [state_pastdivStyle, setstate_pastdivStyle] = useState("upLoadImage");


    const uploadChoiceProps = {
        name: "fileData",
        multiple: true,
        showUploadList: false, // set to only upload one file
        //fileList: getFileList(),
        customRequest: info => {
            startUpload(info.file, "1", uploadChoiceSuccessCallback);
        },
        /*onRemove: file => {
            removeChoice(file.uid);
        },*/
        beforeUpload: file => {
            if(state_choices.length >= choiceNum){
                MessageBox.danger({ text: props.t("uploadImageCountErr", { choiceNum: choiceNum }), duration: 5000 });
                return false;
            }

            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJpgOrPng) {
                MessageBox.danger({ text: props.t("uploadImageFormatLimited"), duration: 5000 });
                return false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                MessageBox.danger({ text: props.t("uploadImageSizeLimited", { fileSize: 5 }), duration: 5000 });
                return false;
            }
            return isJpgOrPng && isLt5M;
        }
    };

    const startUpload = (file, setStateVal, uploadSuccessCallback) => {
        setstate_choiceLoading(setStateVal);
        WordEditService.uploadImage(
            file,
            response => {
                uploadSuccessCallback(response);
                setstate_choiceLoading("");
            },
            error => {
                setstate_choiceLoading("");
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const uploadChoiceSuccessCallback = (data) => {
        const { virtualPath } = data;
        setstate_choices(preState => {
            let choices_new = _.clone(preState || []);
            if(choices_new.length >= choiceNum){
                MessageBox.danger({ text: props.t("uploadImageCountErr", { choiceNum: choiceNum }), duration: 5000 });
            }else{
                choices_new.push(virtualPath);
            }
            return choices_new;
        });
    };

    const removeChoice = (index) => {
        let choices_new = _.clone(state_choices || []);
        choices_new.splice(index, 1);
        setstate_choices(choices_new);
    };

    const upPastePic = (event) =>{
        if(state_choices.length >= choiceNum){
            MessageBox.danger({ text: props.t("uploadImageCountErr", { choiceNum: choiceNum }), duration: 5000 });
            return false;
        }else{
            var getFile = getPastePic(event);
            if(getFile){
                startUpload(getFile, "2", uploadChoiceSuccessCallback);
            }
        }
    }

    const changePastStyle = (kind) =>{
        if(kind==="click")
        {
            setstate_pastdivStyle("upLoadImage choiceDiv");
        }else{
            setstate_pastdivStyle("upLoadImage");
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="form-group">
                        <label className="form-control-label">{props.t("choices", { choiceNum: choiceNum })}</label>
                    </div>
                </div>
            </div>
            <div className="row uploadImageDiv" style={{marginTop:"-20px"}}>
                <div className="col-lg-12">
                    <div style={{float:"left", marginRight:"20px"}}>
                        <Dragger {...uploadChoiceProps}>
                            <div style={{textAlign:"center",marginTop:"-10px",marginBottom:"-10px",width:"300px",height:"62px"}}>
                            {
                                state_choiceLoading === "1" ? <span><i class="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                : <div>
                                    <i className="fa fa-inbox" style={{fontSize:"30px", color:"#11cdef"}}></i>
                                    <div style={{fontSize:"16px",marginTop:"5px",paddingLeft:"5px",paddingRight:"5px"}}>{props.t("uploadTitle")}</div>
                                   </div>
                            }
                            </div>
                        </Dragger>
                        {choicesFieldError && choicesFieldError[0] && <span className="text-danger">{choicesFieldError[0].message}</span>}
                    </div>
                    <div style={{float:"left", marginRight:"20px",paddingTop:"30px"}}>
                        {props.t("or")}
                    </div>
                    <div className={state_pastdivStyle} tabIndex="-1"
                        onFocus={(e) => {changePastStyle("click")}}
                        onBlur={(e) => {changePastStyle("outClick")}}
                        onPaste={(e) => { upPastePic(e)}} >
                            {
                                state_choiceLoading === "2" ? <span><i class="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                : <div style={{marginTop:"1px"}}>
                                      <i className="fa fa-paste" style={{fontSize:"30px", color:"#2dce89"}}></i>
                                      <div style={{fontSize:"16px",marginTop:"5px"}}>{props.t("pasteTitle")}</div>
                                  </div>
                            }
                    </div>
                </div>
                <div style={{marginLeft:"13px",marginTop:"5px"}}>
                    {state_choices && state_choices.map((imagePath, i) => {
                        return(
                            <div className="imgList">
                                <div style={{float:"left", cursor:"pointer"}}>
                                    <i class="fa fa-paperclip" aria-hidden="true" style={{marginRight:"5px"}}></i>
                                </div>
                                <a rel="noopener noreferrer nofollow" style={{float:"left"}} target="_blank" href={Helper.convertToFileServerPath(imagePath)}>
                                    {imagePath.substring(imagePath.lastIndexOf("/") +1 )}
                                </a>
                                <div style={{float:"right", cursor:"pointer"}}>
                                    <i class="fa fa-times" aria-hidden="true" style={{marginLeft:"10px"}}
                                        onClick={(e) => {removeChoice(i)}}
                                    ></i>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="row" style={{marginTop:"10px"}}>
                <div className="col-lg-12">
                    <div className="form-group">
                        {state_choices && state_choices.map((imagePath, i) => {
                            return (
                                <div key={`choice-${i}`} style={{ float:"left"}}>
                                    <div className="mx-3">
                                        <Media>
                                            <img src={Helper.convertToFileServerPath(imagePath)} alt="..." style={{ width: "200px", height: "140px" }} />
                                        </Media>
                                        <input type="hidden" name={choicesFieldName + `[${i}]`} defaultValue={imagePath} ref={register} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}
function getPastePic(event){
    var items = (event.clipboardData && event.clipboardData.items) || [];
    var file = null;
    if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                file = items[i].getAsFile();
                break;
            }
        }
    }

    return file;
}

export default withTranslation(uid)(ImageField);